/** @format */

import Vue from "vue";
import Vuex from "vuex";
import {
  getPartnerSettings,
  updatePartnerSettings,
  getPortfolios,
  getSessionInfo,
  getSelectedPartner,
  // getSessionInfo
} from "@/gateway";
Vue.use(Vuex);

async function doAction(commit, mutation, action) {
  commit("loading", true);
  try {
    commit(mutation, await action());
  } finally {
    commit("loading", false);
  }
}

const actions = {
  async initialLoad(context) {
    // get initial url
    // console.log("ENV 1", process.env.VUE_APP_APP_NAME);
    // console.log("ENV 2", process.env.APP_NAME);
    if (localStorage.getItem("ss-tok")) {
      //Vue.axios.defaults.headers.common.Authorization = `Bearer ${localStorage.plinktrackerjwt}`;

      const response = await getSessionInfo();

      context.commit("sessionInfo", response);

      context.commit("partnerId", response.partnerId);
    } else {
    }
  },

  async loadSettings({ commit }) {
    console.log("loading settings");
    console.log(process.env.VUE_APP_CUSTOM_NAME);
    commit("appName", process.env.VUE_APP_CUSTOM_NAME);
    const session = await getSessionInfo();
    const response = await getPartnerSettings();
    const partnerNaming = await getSelectedPartner();

    commit("sessionInfo", session);

    commit("partnerId", partnerNaming.partnerId);
    commit("partnerName", partnerNaming.partnerName);
    commit("partnerSettings", response.partnerSettings);
    commit("partnerBackgroundUrl", response.partnerBackgroundUrl);
    commit("partnerLogoUrl", response.partnerLogoUrl);

    const response2 = await getPortfolios();
    commit("portfolios", response2.result);
    // commit("hellosignapikey", response.hellosignapikey);
  },
  async updateAppName(context, settings) {
    context.commit("appName", settings);
  },
  async updatePartnerName(context, settings) {
    context.commit("partnerName", settings);
  },
  async updatePartnerId(context, settings) {
    context.commit("updatePartnerId", settings);
  },
  async updateSettings(context, settings) {
    context.commit("partnerBackgroundUrl", settings.partnerBackgroundUrl);
  },
  async updateBackground(context, settings) {
    //const response = await updatePartnerSettings(settings);
    const currentSettings = await getPartnerSettings();
    currentSettings.partnerBackgroundUrl = settings;
    const newSettingsResponse = await updatePartnerSettings(currentSettings);
    context.commit("partnerBackgroundUrl", settings);
  },
};

const mutations = {
  appName(state, name) {
    state.appName = name;
  },
  sessionInfo(state, user) {
    state.user.id = user.userAuthId; // user.id;
    // state.user.partnerId = user.partnerId;

    state.user.isAuthenticated = user.isAuthenticated;
    state.user.username = user.userName;
    state.user.email = user.email;
    state.user.displayName = user.displayName;
    state.user.roles = user.roles;
    state.user.permissions = user.permissions;
    if (user.userPartners) state.user.userPartners = user.userPartners;
  },
  updatePartnerId(state, config) {
    state.partnerId = config;
    state.user.partnerId = config;
  },
  partnerName(state, config) {
    state.partnerName = config;
  },
  partnerId(state, config) {
    state.partnerId = config;
  },
  hellosignapikey(state, config) {
    state.hellosignapikey = config;
  },
  partnerSettings(state, config) {
    state.partnerSettings = config;
  },
  partnerBackgroundUrl(state, config) {
    state.partnerBackgroundUrl = config;
  },
  partnerLogoUrl(state, config) {
    state.partnerLogoUrl = config;
  },
  portfolios(state, config) {
    state.portfolios = config;
  },
};

export const getters = {
  isAuthenticated: (state) => state.user.isAuthenticated == true,
  /* loading: true  state => state.loading
  isAuthenticated: state => state.sessionInfo != null,
  user: state => state.sessionInfo,
  userId: state =>
    state.sessionInfo &&
    state.sessionInfo.userAuthId &&
    parseInt(state.sessionInfo.userAuthId),
  userName: state => state.sessionInfo && state.sessionInfo.userName*/
};
export default new Vuex.Store({
  state: {
    user: {
      id: null,
      email: "",
      displayName: "",
      userName: "",
      isAuthenticated: false,
      partnerId: 0,
      roles: [],
      permissions: [],
      userPartners: [],
    },
    appName: "",
    partnerId: 0,
    partnerName: "",
    partnerSettings: {},
    partnerBackgroundUrl: "",
    partnerLogoUrl: "",
    //
    portfolios: [],
    loading: false,
  },
  mutations: mutations,
  actions: actions,
  getters: getters,
});
